<button *ngIf="!link && !icon && !multiAction"
        mat-raised-button
        [color]="destructive ? 'warn': !secondary ? color : undefined"
        [style.width]="width"
        class="button"
        [disabled]="disabled"
        (click)="clicked.emit($event)">{{label}}</button>

<button *ngIf="icon && !multiAction && !secondary"
        mat-mini-fab
        [color]="destructive ? 'warn' : color ? color : 'accent'"
        [class.destructive-btn]="destructive"
        class="icon-btn"
        [disabled]="disabled"
        (click)="clicked.emit($event)">
  <mat-icon class="btn-icon" *ngIf="icon">{{icon}}</mat-icon>
  {{label}}
</button>
<button *ngIf="icon && !multiAction && secondary"
        mat-icon-button
        [color]="destructive ? 'warn' : 'accent'"
        [class.destructive-btn]="destructive"
        class="icon-btn"
        [disabled]="disabled"
        (click)="clicked.emit($event)">
  <mat-icon class="btn-icon" *ngIf="icon">{{icon}}</mat-icon>
  {{label}}
</button>

<a *ngIf="!icon && link && !routerLink && !multiAction"
   mat-raised-button
   class="button"
   [href]="href"
   [target]="target">{{label}}</a>

<a *ngIf="!icon && link && routerLink && !multiAction"
   mat-raised-button
   class="button"
   [routerLink]="routerLink">{{label}}</a>

<ng-container *ngIf="multiAction">
  <button mat-raised-button
          [color]="destructive ? 'warn': !secondary ? color : undefined"
          [style.width]="width"
          class="button"
          [class.multi-action]="actions && actions.length > 0"
          [disabled]="disabled"
          (click)="clicked.emit($event)">{{label}}</button>
  <button *ngIf="actions && actions.length > 0"
          [matMenuTriggerFor]="multiActionMenu"
          mat-mini-fab
          [color]="destructive ? 'warn': !secondary ? color : undefined"
          class="multi-action-trigger-btn"
          [disabled]="disabled">
    <mat-icon>{{multiActionFooter ? 'keyboard_arrow_up' : 'expand_more'}}</mat-icon>
  </button>
  <mat-menu #multiActionMenu="matMenu" xPosition="before">
    <button mat-menu-item *ngFor="let action of actions" (click)="actionClick(action)">
      <mat-icon *ngIf="action.icon">{{action.icon}}</mat-icon>
      {{action.label}}
    </button>
  </mat-menu>
</ng-container>
